module.exports = __webpack_public_path__ + "media/assets/fonts/fselliotpro-italic-webfont-f0a703dfb292e1ccf6c886e611e98e53.woff";